export default "__VITE_ASSET__CcGrnc4y__"